<script lang="ts" setup>
import { computed, defineAsyncComponent } from "vue";
import {
  type PictogramName,
  PictogramEnum,
} from "@/shared/@types/PictogramName";

const props = withDefaults(
  defineProps<{
    pictogram: PictogramName;
    size?: "small" | "medium" | "large";
    color?: "red" | "anthracite";
    removePadding?: boolean;
  }>(),
  {
    size: "small",
    color: "red",
    removePadding: false,
  },
);

const component = computed(() => {
  if (props.pictogram) {
    return defineAsyncComponent(
      () => import(`./pictograms/${PictogramEnum[props.pictogram]}.svg`),
    );
  }
  return undefined;
});
</script>

<template>
  <div
    class="pictogram"
    :data-size="size"
    :data-color="color"
    :data-has-no-padding="removePadding"
  >
    <component
      :is="component"
      class="pictogram--icon"
    />
  </div>
</template>

<style scoped>
@import "Pictogram.css";
</style>
